module.exports = __webpack_public_path__ + "static/media/slidePicture3.991d2180.jpg";